import React from 'react';
import Header from '../Header/Header';
import RateContainer from '../Rate/RateContainer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <div className="container">
        <main>
          <RateContainer />
        </main>
      </div>
    </div>
  );
}

export default App;
